<template>
  <Event ref="eventRef" :event="event" @open-edit-component="show">
    <div class="font-bold">
      <div>
        <div class="flex">
          <div class="blueColor leftside">
            {{ t("components.event-action.quality.QualityAssurance.technicalPlaceLabel") }}
          </div>

          <div class="w-75">
            {{ event.tp?.path + " | " + event.tp?.name }}
          </div>
        </div>
        <div v-if="event.orderNumber" class="flex">
          <div class="blueColor leftside">
            {{ t("license.quality.components.QAQualityAssuranceComponent.productionPlanLabel") }}
          </div>
          <!-- Prettier should not make a break in the following div -->
          <div class="w-75 white-space-pre font-bold">{{ event.orderNumber }}</div>
        </div>
        <div class="flex">
          <div class="blueColor leftside">
            {{ t("components.event-action.quality.QualityAssurance.errorOccurrenceLabel") }}
          </div>
          <div class="w-75">
            {{}}
            {{
              t(
                `components.event-action.quality.QualityAssurance.errorOccurrenceOn.${event.errorOccurrenceOn}`,
              )
            }}
          </div>
        </div>
        <div class="flex">
          <div class="blueColor leftside">
            {{ t("components.event-action.quality.QualityAssurance.productFamilyLabel") }}
          </div>
          <div class="w-75">
            {{ productFamily }}
          </div>
        </div>
        <div class="flex">
          <div class="blueColor leftside">
            {{ t("components.event-action.quality.QualityAssurance.errorCatalogsLabel") }}
          </div>
          <div v-if="event.errorCatalogs && event.errorCatalogs.length > 0" class="w-75">
            <span>{{
              event.errorCatalogs.map((error) => t(`dynamic.${error.nameId}`)).join(", ")
            }}</span>
          </div>
          <div v-else class="w-75 text-error">
            {{ t("components.event-action.quality.QualityAssurance.noErrorCatalogeLabel") }}
          </div>
        </div>
        <div class="flex">
          <div class="blueColor leftside">
            {{ t("components.event-action.quality.QualityAssurance.descriptionLabel") }}
          </div>
          <!-- Prettier should not make a break in the following div -->
          <div class="w-75 white-space-pre font-bold">{{ event.description }}</div>
        </div>
      </div>
    </div>

    <template #trailingHeaderAdditionsFront>
      <AttachmentBadge :files="event.Folder?.files" />
    </template>
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <template #editComponent>
      <QualityAssuranceModal
        ref="qualityAssuranceModal"
        :event="{ ...event, fileIds: event.Folder?.files.map((f) => f.id) ?? [] }"
      />
    </template>
  </Event>
</template>

<script setup lang="ts">
import { computed, type PropType, ref } from "vue";
import { useTranslation } from "@/language/translation";
import { type EventListEventFields_QualityAssurance_Fragment, ErrorOccurrenceOn } from "@/graphql";
import AttachmentBadge from "@/components/badges/AttachmentBadge.vue";
import Event from "../event/EventComponent.vue";
import QualityAssuranceModal from "./modal/QualityAssuranceModal.vue";

const props = defineProps({
  event: {
    type: Object as PropType<EventListEventFields_QualityAssurance_Fragment>,
    required: true,
  },
});
const eventRef = ref<InstanceType<typeof Event>>();
const { t } = useTranslation();

const qualityAssuranceModal = ref<null | InstanceType<typeof QualityAssuranceModal>>(null);

const show = () => {
  qualityAssuranceModal.value?.show();
};
defineSlots();

defineExpose({
  eventRef,
});

const productFamily = computed(() =>
  props.event.errorOccurrenceOn === ErrorOccurrenceOn.INPUT
    ? `${props.event.inputMaterial?.nameId != null ? t(`dynamic.${props.event.inputMaterial.nameId}`) : ""}${props.event.inputMaterialCharacteristic?.name ? ` [${props.event.inputMaterialCharacteristic.name}]` : ""}`
    : `${props.event.outputMaterial?.nameId != null ? t(`dynamic.${props.event.outputMaterial.nameId}`) : ""}${props.event.outputMaterialCharacteristic?.name ? ` [${props.event.outputMaterialCharacteristic.name}]` : ""}`,
);
</script>
<style>
.blueColor {
  color: #166b95;
}
.leftside {
  width: 150px;
}
</style>
